'use strict';

const $ = window.jQuery;

module.exports = function () {
    if ( $('.header').length <= 0 ) {
        return
    }

    $('#toggleMobile').on('click', function () {
        $(this).toggleClass('is-open');
        $('#navMobile').toggleClass('is-open');
        $('body').toggleClass('no-scroll');
        $('.nav-mobile-l2').removeClass('is-active');
    });

    $('#accountMobileDeployer').on('click', function (e) {
        $('#accountMobile').toggleClass('is-active');
        e.stopPropagation();
    });

    // Menus
    $('.nav-mobile-l1__link').on('click', function (e) {
        if ($(this).parent().hasClass('menu-item-has-children')) {
            e.preventDefault();
            $(this).next().addClass('is-active');
        }
    });

    $('.nav-mobile-l2__back').on('click', function () {
        $('.nav-mobile-l2').removeClass('is-active');
    });
}
